import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface PrimaryButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  size?: 'md' | 'lg';
  fullWidth?: boolean;
  showArrow?: boolean;
  className?: string;
}
export function PrimaryButton({
  children,
  onClick,
  href,
  size = 'lg',
  fullWidth = false,
  showArrow = true,
  className = ''
}: PrimaryButtonProps) {
  const sizeClasses = size === 'lg' ? 'px-8 py-4 text-base sm:text-lg' : 'px-6 py-3 text-sm sm:text-base';
  const sharedClassName = `group inline-flex items-center justify-center gap-2 ${sizeClasses} ${fullWidth ? 'w-full' : ''} rounded-xl border-2 border-naranja bg-gradient-to-br from-azul to-azul-dark font-heading font-semibold uppercase tracking-wide text-white shadow-card transition-[filter,transform] duration-200 hover:brightness-90 active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-azul focus-visible:ring-offset-2 focus-visible:ring-offset-white ${className}`;
  const content = <>
      {children}
      {showArrow && <ArrowRightIcon size={size === 'lg' ? 20 : 18} className="transition-transform duration-200 group-hover:translate-x-1" data-id="element-311" data-mp="bsvoh5qobje6" />}
    </>;
  if (href) {
    return <a href={href} className={sharedClassName} data-id="element-312" data-mp="lq9uscivursr">
        {content}
      </a>;
  }
  return <button onClick={onClick} className={sharedClassName} data-id="element-313" data-mp="3u63awq9ay19a">
      {content}
    </button>;
}